import { ChevronLeftIcon } from "@chakra-ui/icons";
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import LoadingPage from "@components/Loader/LoadingPage";
import { DEFAULT_LANGUAGE } from "@models/language";
import * as Sentry from "@sentry/browser";
import Link from "next/link";
import { useEffect, useMemo } from "react";
import { usePaymentStore } from "../../../payment";
import CheckoutDiscountInput from "./CheckoutDiscountInput";
import CheckoutOrderItem from "./CheckoutOrderItem";

const _t = (key?: string, language = DEFAULT_LANGUAGE) => key || "";

const CheckoutOrderSelect = () => {
  const transaction = usePaymentStore((state) => state.transaction);
  const event = usePaymentStore((state) => state.event);

  const tiers = useMemo(
    () =>
      (event?.tiers.filter((tier) => tier.paymentConfig) || []).sort(
        (a, b) => a.order - b.order || (a.paymentConfig?.inviteOnly ? 1 : -1)
      ),
    [event]
  );

  useEffect(() => {
    Sentry.addBreadcrumb({
      category: "checkout:selectItems",
      level: "info",
    });
  }, []);

  useEffect(() => {
    console.log("event changed", event);
  }, [event]);

  if (!event || !transaction) return <LoadingPage />;

  return (
    <div className="flex-grow flex flex-col w-full overflow-y-auto max-w-[60rem] dark:text-white p-1">
      <CheckoutDiscountInput />

      {/* Order Select */}
      <div className="flex flex-col gap-4">
        {tiers.map((tier, index) => {
          return <CheckoutOrderItem key={index} tier={tier} index={index} />;
        })}
      </div>
    </div>
  );
};

export const CheckoutOrderSelectTitle = () => {
  return (
    <Flex direction="row" alignItems="center" gap={4} px={[8, 0]}>
      <Link href={window.location.pathname.replace(/\/checkout.+/, "/")}>
        <ChevronLeftIcon
          cursor="pointer"
          boxSize="2rem"
          color={useColorModeValue("", "white")}
        />
      </Link>
      <Text fontSize="2xl" textColor={useColorModeValue("", "white")}>
        {_t("Cart")}
      </Text>
    </Flex>
  );
};

export default CheckoutOrderSelect;
